import { IBanner } from '../models/responseModels'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class GetBannerByIdApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/banner',
      requesterInfo,
    })
  }

  public async getBannerById(Id: number): Promise<IBanner> {
    this.props.url = `${this.props.url}/${Id}`
    return await this.getAsync<IBanner>()
  }
}
